var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTripleDownIcon = function SvgTripleDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98 5.313a.5.5 0 0 1 .65-.048l.057.048L8 9.626l4.313-4.313a.5.5 0 0 1 .651-.048l.056.048a.5.5 0 0 1 .049.651l-.049.056-4.666 4.667a.5.5 0 0 1-.651.048l-.057-.048L2.98 6.02a.5.5 0 0 1 0-.707Z",
    fill: "#484F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98 13.313a.5.5 0 0 1 .65-.049l.057.049L8 17.626l4.313-4.313a.5.5 0 0 1 .651-.049l.056.049a.5.5 0 0 1 .049.651l-.049.056-4.666 4.667a.5.5 0 0 1-.651.048l-.057-.048L2.98 14.02a.5.5 0 0 1 0-.707Z",
    fill: "#6C727E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98 13.313a.5.5 0 0 1 .65-.049l.057.049L8 17.626l4.313-4.313a.5.5 0 0 1 .651-.049l.056.049a.5.5 0 0 1 .049.651l-.049.056-4.666 4.667a.5.5 0 0 1-.651.048l-.057-.048L2.98 14.02a.5.5 0 0 1 0-.707Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98 21.313a.5.5 0 0 1 .65-.048l.057.048L8 25.626l4.313-4.313a.5.5 0 0 1 .651-.048l.056.048a.5.5 0 0 1 .049.651l-.049.056-4.666 4.667a.5.5 0 0 1-.651.048l-.057-.048L2.98 22.02a.5.5 0 0 1 0-.707Z",
    fill: "#ADADAD"
  })));
};
export default SvgTripleDownIcon;